import React from 'react';

import ServerError from '../components/ServerError';

export default ({ addonDiscoveryConfig, isServerError, routes, serverErrorPaths, statusCode }) =>
  isServerError
    ? serverErrorPaths.map(p => ({
        exact: true,
        name: 'serverErrorScreen',
        path: p,
        // eslint-disable-next-line react/display-name
        render: props => (
          <ServerError
            {...props}
            homeLink={addonDiscoveryConfig.links.home}
            statusCode={statusCode}
          />
        ),
      }))
    : routes();
